import { FunctionComponent } from "react";
import "./TOSHeader.css"
import { useStoreState } from "../../store";

import LOGO_SRC from "../../Icons/Logo.svg";
import INFO_SRC from "../../Icons/Info.svg";
import USER_SRC from "../../Icons/user.svg";
import SYSTEM_SRC from "../../Icons/gear.svg";

import { useNavigate } from "react-router";
import {Tooltip} from "../../components/Tooltip";
import { getAppVersionLabel } from "../../utility/appVersion";
import { useCan } from "../../access/useCan";

type CSMShopfloorHeaderProps = {
  onLogoContainerClick?: () => void;
};

const CSMShopfloorHeader: FunctionComponent<CSMShopfloorHeaderProps> = ({
  onLogoContainerClick,
}) => {
  const navigate = useNavigate();

  // --------- Store state needed for this header -----------
  const user = useStoreState((s) => s.user);
  const isManagerMode = useStoreState((s) => s.appSettings.isManagerMode);

  // The gear, as in the main header: Manager view, and the access map grants `manageSettings`,
  // which `/system` needs. False while access is loading, so it does not flash in. This header
  // draws no tabs.
  const canOpenSettings = useCan("manageSettings");

  // --------- Handlers ----------------------
  const handleLogoClick = () => {
    if (onLogoContainerClick) onLogoContainerClick();
    else navigate("/home");
  };

  const goSystem = () => navigate("/system");
  const doLogout = () => navigate("/logout");

  return (
    <div className="csm-header">
      {/* LEFT: Logo + app names */}
      <div className="logo-parent">
        <div
          className="logo"
          onClick={handleLogoClick}
          role="button"
          aria-label="Home"
          tabIndex={0}
        >
          <img className="logo-child" src={LOGO_SRC} alt="" />
        </div>

        <div className="frame-parent">
          <div
            style={{
              color: "#36424A",   // Figma; was "black"
              fontSize: 20,
              fontFamily: "Noto Sans",
              fontWeight: "300",
              // "33px", not 33 — see the matching note in CSMShopfloorHeader.tsx.
              // Unitless 33 is a 660px line box, which breaks the phone header
              // once it's allowed to size to its content.
              lineHeight: "33px",
              wordWrap: "break-word",
            }}
          >
            CSM
          </div>                  
        </div>
      </div>

      {/* RIGHT: utilities only (dropdowns removed) */}
      <div className="button-link-parent">
        
        {/* User name (click => logout) */}
        <div
          className="utility-link"
          onClick={doLogout}
          role="button"
          title="Log out"
          tabIndex={0}
          onKeyDown={(e) => e.key === "Enter" && doLogout()}
        >
          <img className="user-icon" alt="" src={USER_SRC} />
          <div className="select-warehouse">
            {(user as any)?.info?.name ?? (user as any)?.fullName ?? "User"}
          </div>
        </div>

        {/* Settings gear: Manager view, for a user who may open /system. */}
        {isManagerMode && canOpenSettings && (
          <div
            className="utility-link"
            onClick={goSystem}
            role="button"
            title="Settings"
            tabIndex={0}
            onKeyDown={(e) => e.key === "Enter" && goSystem()}
          >
            <img className="user-icon csm-gear-icon" alt="" src={SYSTEM_SRC} />
            <div className="select-warehouse"></div>
          </div>
        )}

        {/* Info (about) */}
        <div className="info-wrapper" role="button" tabIndex={0} aria-label="About">
  

  {/* Version comes from the AppVersion Key Vault secret, not source. */}
  <Tooltip text={getAppVersionLabel()}>
    <img className="path-346-icon" alt="" src={INFO_SRC} />
  </Tooltip>
</div>
      </div>
    </div>
  );
};

export default CSMShopfloorHeader;